module.exports = __webpack_public_path__ + "img/20230803115839632ckf.35db369d.jpg";